<div class="discoveryWizardSelectableResponse-container">
    <button mat-mini-fab [ngStyle]="{'background-color':bkColor}" (click)="emitResposneSelectedEvent()"><mat-icon [ngStyle]="{'color':iconColor}">check_circle</mat-icon></button>
    <span class="discoveryWizardSelectableResponse-responseText" [ngStyle]="{'background-color':responseBkColor}">{{responseText}}</span>
</div>